// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2Nu9l","header":"PatientBlock_header__3WMKa","label":"PatientBlock_label__16-7g","option":"PatientBlock_option__1hINl"};